import React from "react"

interface WatermarkOverlayProps {
  watermarkText: string
  className?: string
  style?: React.CSSProperties
}

const WatermarkOverlay: React.FC<WatermarkOverlayProps> = ({
  watermarkText,
  className = "",
  style = {}
}) => {
  if (!watermarkText) return null

  return (
    <div
      className={`absolute inset-0 pointer-events-none z-30 ${className}`}
      style={style}
    >
      {/* Bottom Right Watermark */}
      <div className="absolute bottom-2 right-2 bg-black/50 text-white text-xs px-2 py-1 rounded">
        {watermarkText}
      </div>
    </div>
  )
}

export default WatermarkOverlay